
import React from "react";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";

interface MessageInputProps {
  message: string;
  setMessage: (message: string) => void;
  placeholder?: string;
}

const MessageInput: React.FC<MessageInputProps> = ({
  message,
  setMessage,
  placeholder = "Typ je feedback of vraag hier...",
}) => {
  // Check for inappropriate content (simple implementation)
  const checkContent = (text: string) => {
    const inappropriateWords = [
      "scheldwoord1", "scheldwoord2", "ongepast1"
      // Add more inappropriate words as needed
    ];
    
    return inappropriateWords.some(word => 
      text.toLowerCase().includes(word.toLowerCase())
    );
  };

  const handleMessageChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newText = e.target.value;
    setMessage(newText);
    
    // Check for inappropriate content as user types
    if (checkContent(newText)) {
      toast.warning("Let op: je bericht lijkt ongepaste inhoud te bevatten");
    }
  };

  return (
    <Textarea
      placeholder={placeholder}
      value={message}
      onChange={handleMessageChange}
      className="min-h-[100px] resize-none"
    />
  );
};

export default MessageInput;
